import { Card, CardContent } from "@/components/ui/card";
import { Shield, Sparkles, Wind, CheckCircle2, Heart, Users } from "lucide-react";

const SafetyProtocols = () => {
  const protocols = [
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: "Enhanced Sanitization",
      description: "EPA-approved disinfectants used on all high-touch surfaces before and after each ride"
    },
    {
      icon: <Wind className="w-8 h-8" />,
      title: "Air Purification",
      description: "HEPA air filtration systems and fresh air circulation throughout every journey"
    },
    {
      icon: <CheckCircle2 className="w-8 h-8" />,
      title: "Driver Health Screening",
      description: "Daily temperature checks and health assessments for all chauffeurs"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Personal Protection",
      description: "Masks, gloves, and hand sanitizer available upon request for all passengers"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Contactless Service",
      description: "Digital payments, touchless greetings, and minimal contact protocols available"
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Health First Policy",
      description: "Flexible cancellation and rescheduling for any health-related concerns"
    }
  ];

  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase">
            Your Safety is Our Priority
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground">
            Enhanced Safety & Health Protocols
          </h2>
          <p className="text-muted-foreground text-lg mt-4 max-w-2xl mx-auto">
            We maintain the highest standards of cleanliness and safety in our luxury car service San Antonio, ensuring your complete peace of mind with every journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mb-12">
          {protocols.map((protocol, index) => (
            <Card key={index} className="card-luxury hover:scale-105 transition-transform duration-300">
              <CardContent className="p-8 space-y-4 text-center">
                <div className="flex justify-center text-primary">{protocol.icon}</div>
                <h3 className="text-xl font-semibold text-foreground">{protocol.title}</h3>
                <p className="text-muted-foreground">{protocol.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="card-luxury max-w-4xl mx-auto border-2 border-primary/20">
          <CardContent className="p-8">
            <h3 className="text-2xl font-serif font-bold text-foreground mb-4 text-center">
              Our Commitment to Excellence
            </h3>
            <p className="text-muted-foreground text-center leading-relaxed mb-6">
              At Rick's Black Car Service, your health and safety are paramount. We follow CDC guidelines and industry best practices to ensure every ride meets the highest standards of cleanliness and protection.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-muted-foreground">Vehicles detailed and sanitized between each ride</span>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-muted-foreground">Chauffeurs equipped with PPE and sanitizing supplies</span>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-muted-foreground">Regular vehicle maintenance and mechanical inspections</span>
              </div>
              <div className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-muted-foreground">Compliance with all local and state health regulations</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default SafetyProtocols;
